import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner, pageGifLoader } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function storeTourFilters(list) {
    return {
        type: 'STORE_TOUR_FILTERS',
        list: list.data
    }
}

export function getDayTourFilters() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/daytours/filters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeTourFilters(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function stoteTourDetailsUpdate(bool) {
    return {
        type: 'STORE_TOUR_DETAILS_UPDATE', bool
    }
}

export function storeTourList(list) {
    return {
        type: 'STORE_TOUR_LISTS',
        list: list.data
    }
}

export function clearTourList() {
    return { type: 'CLEAR_TOUR_LISTS' }
}

export function getDayTourList(search = "", location = "", cat = "", type = "", rate = "", price = "") {
    return function (dispatch) {
        dispatch(pageGifLoader(true));
        dispatch(clearTourList());
        fetch(API_URL + '/api/daytours/list?key=' + search + "&location=" + location + "&category=" + cat + "&type=" + type + "&rating=" + rate + "&price_range=" + price, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));
                    if (json.success && json.data.tours.length > 0) {
                        dispatch(getDayTourListMore(search, location, cat, type, rate, price, json.data.tours[json.data.tours.length - 1].id, false));
                    }
                    dispatch(storeTourList(json));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function updateTourListArray(bool) {
    return {
        type: 'UPDATE_TOUR_LIST_ARRAY', bool
    }
}


export function updateTourList(data) {
    return {
        type: 'UPDATE_MORE_TOUR_LISTS',
        list: data
    }
}

export function getDayTourListMore(search = "", location = "", cat = "", type = "", rate = "", price = "", id, loader = false) {
    return function (dispatch) {
        dispatch(pageGifLoader(loader));
        dispatch(updateTourListArray(false));
        fetch(API_URL + '/api/daytours/listMore?key=' + search + "&location=" + location + "&category=" + cat + "&type=" + type + "&rating=" + rate + "&price_range=" + price + "&id=" + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));
                    dispatch(updateTourListArray(json.success && json.data.tours.length > 0));
                    dispatch(updateTourList(json.data));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeRentCarList(list) {
    return {
        type: 'STORE_RENT_CAR_LIST',
        list: list.data
    }
}

export function getRentCarList() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/rent_car/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeRentCarList(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeBlogList(list) {
    return {
        type: 'STORE_BLOG_LIST',
        list: list.data
    }
}

export function getBlogList() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/blogs/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeBlogList(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeCustomerCareDetails(list) {
    return {
        type: 'STORE_CUSTOMER_CARE_LIST',
        list: list.data
    }
}

export function getCustomerCareDetails() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/customer_care/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeCustomerCareDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeTravelEssenseDetails(list) {
    return {
        type: 'STORE_TRAVEL_ESSENSE_DETAILS',
        list: list.data
    }
}

export function getTravelEssenseDetails() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/travel_essense/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeTravelEssenseDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeHyperTypeLinkTours(list) {
    return {
        type: 'STORE_HYPER_LINK_TYPE_TOURS',
        data: list.data
    }
}

export function getHyperLinkTypeTours(type, peram) {
    return function (dispatch) {
        dispatch(pageGifLoader(true));
        dispatch(startLoading());
        fetch(API_URL + '/api/hyperlink/tours?type=' + type + "&peram=" + peram, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(pageGifLoader(false));
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeHyperTypeLinkTours(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

